import { Injectable } from '@angular/core';
import countries from '../../../../../assets/data/countries.json';
import { ICountry } from './country.interface';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  defaultCountry = 'israel';
  normalizedCountries: ICountry[];
  capCountries: ICountry[];

  constructor() {
    this.normalizedCountries = this.normalizeAllNames();
  }

  getCountryInfo(countryName: string): ICountry {
    const normalizedName = this.normalize(countryName);
    const filtered: ICountry[] = this.normalizedCountries.filter(country => {
      return (normalizedName === country.normName) || (normalizedName === country.normEngName);
    });

    return filtered[0];
  }

  getCountryById(id: any): ICountry {
    const filtered: ICountry[] = this.normalizedCountries.filter(country => {
      return (id === country.id);
    });

    return filtered[0];
  }

  getDefaultCountry(): ICountry {
    return this.getCountryInfo(this.defaultCountry);
  }

  private normalizeAllNames(): ICountry[] {
    return countries.filter((country: ICountry) => {
      const nameHE = this.normalize(country.nameHE);
      const nameEN = this.normalize(country.nameEN);
      country.normName = nameHE;
      country.normEngName = nameEN;
      return country;
    });
  }

  private normalize(str: string): string {
    return str.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
  }

}

